export const INIT_COLLECTION = 'INIT_COLLECTION'
export const INIT_COLLECTION_SUCCESS = 'INIT_COLLECTION_SUCCESS'
export const INIT_COLLECTION_FAILED = 'INIT_COLLECTION_FAILED'

export const SET_COLLECTION_VIEW = 'SET_COLLECTION_VIEW'

export const LOCK_COL_FETCH = 'LOCK_COL_FETCH'
export const TOGGLE_HIDE_FETCH = 'TOGGLE_HIDE_FETCH'
export const TOGGLE_SORT_FETCH = 'TOGGLE_SORT_FETCH'
export const SET_FILTERS_FETCH = 'SET_FILTERS_FETCH'
export const REORDER_COLUMNS_FETCH = 'REORDER_COLUMNS_FETCH'
export const RESIZE_COLUMN_FETCH = 'RESIZE_COLUMN_FETCH'
export const TOGGLE_READONLY = 'TOGGLE_READONLY'

export const VIEW_STATE_UPDATE_SUCCESS = 'VIEW_STATE_UPDATE_SUCCESS'
export const VIEW_STATE_UPDATE_FAILED = 'VIEW_STATE_UPDATE_FAILED'

export const DOCUMENT_ADD_FETCH = 'DOCUMENT_ADD_FETCH'
export const DOCUMENT_ADD_SUCCESS = 'DOCUMENT_ADD_SUCCESS'
export const DOCUMENT_ADD_FAILED = 'DOCUMENT_ADD_FAILED'

export const DOCUMENT_DELETE_FETCH = 'DOCUMENT_DELETE_FETCH'
export const DOCUMENT_DELETE_SUCCESS = 'DOCUMENT_DELETE_SUCCESS'
export const DOCUMENT_DELETE_FAILED = 'DOCUMENT_DELETE_FAILED'

export const DOCUMENT_SELECTION_CHANGE = 'DOCUMENT_SELECTION_CHANGE'

export const DOCUMENT_UPDATE_FETCH = 'DOCUMENT_UPDATE_FETCH'
export const DOCUMENTS_UPDATE_FETCH = 'DOCUMENTS_UPDATE_FETCH'

export const RESET_CREATED_ROW = 'RESET_CREATED_ROW'

export const SET_TEXT_FILTER = 'SET_TEXT_FILTER'
export const SET_TEXT_FILTER_SUCCESS = 'SET_TEXT_FILTER_SUCCESS'
export const SET_TEXT_FILTER_FAILED = 'SET_TEXT_FILTER_FAILED'

export const SET_FEEDBACK = 'SET_FEEDBACK'
export const SET_FEEDBACK_SUCCESS = 'SET_FEEDBACK_SUCCESS'
export const SET_FEEDBACK_FAILED = 'SET_FEEDBACK_FAILED'

export const CREATE_VIEW_FETCH = 'CREATE_VIEW_FETCH'
export const CREATE_VIEW_SUCCESS = 'CREATE_VIEW_SUCCESS'
export const CREATE_VIEW_FAILED = 'CREATE_VIEW_FAILED'

export const SELECT_VIEW = 'SELECT_VIEW'

export const DELETE_VIEW_FETCH = 'DELETE_VIEW_FETCH'
export const DELETE_VIEW_SUCCESS = 'DELETE_VIEW_SUCCESS'
export const DELETE_VIEW_FAILED = 'DELETE_VIEW_FAILED'

export const UPDATE_VIEW_FETCH = 'UPDATE_VIEW_FETCH'
export const UPDATE_VIEW_SUCCESS = 'UPDATE_VIEW_SUCCESS'
export const UPDATE_VIEW_FAILED = 'UPDATE_VIEW_FAILED'

export const REORDER_VIEWS_FETCH = 'REORDER_VIEWS_FETCH'
export const REORDER_VIEWS_SUCCESS = 'REORDER_VIEWS_SUCCESS'
export const REORDER_VIEWS_FAILED = 'REORDER_VIEWS_FAILED'

export const RESET_VIEWS = 'RESET_VIEWS'

export const VIEW_CLONE_FETCH = 'VIEW_CLONE_FETCH'
export const VIEW_CLONE_SUCCESS = 'VIEW_CLONE_SUCCESS'
export const VIEW_CLONE_FAILED = 'VIEW_CLONE_FAILED'

